<template>
  <div :class="classes">
    <div @click.capture="verifyDemo">
      <a :to="videoRoute.href" @click.prevent="replaceRoute ? $router.replace(videoRoute.route) : $router.push(videoRoute.route)">
        <div @click="$emit('click')" class="image-container">
          <img
            :src="video.thumbnail"
            :srcset="imageSrcSet"
            :sizes="imageSizes"
            loading="lazy"
            :alt="video.description"
          />
        </div>
        <p>{{ index }} - {{ video.title }}</p>
      </a>
    </div>
  </div>
</template>

<script>
import { resizedImageUrl } from '@/js/imageUtils'
export default {
  name: 'video-thumbnail',
  props: {
    video: {
      type: Object,
      required: true
    },
    playlistGroupId: {
      type: String,
      required: true
    },
    playlistId: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    replaceRoute: {
      type: Boolean,
      default: false
    },
    hasAnimation: Boolean,
    isHighlighted: Boolean,
    isDemo: Boolean
  },
  data() {
    return {
      imageSizes: '(max-width: 374px) 180px, ' +
        '(max-width: 725px) 240px, ' +
        '420px'
    }
  },
  computed: {
    imageSrcSet() {
      return `${resizedImageUrl(180, this.video.thumbnail)} 180w, ` +
        `${resizedImageUrl(240, this.video.thumbnail)} 240w, ` +
        `${resizedImageUrl(420, this.video.thumbnail)} 420w`
    },
    classes() {
      let classes = [ 'video' ]

      if (this.hasAnimation) {
        classes.push('animated')
      }

      if (this.isHighlighted) {
        classes.push('highlighted')
      }

      return classes.join(' ')
    },
    videoRoute(videoId) {
      return this.$router.resolve({
        name: 'watch-video',
        params: {
          playlistGroupId: this.playlistGroupId,
          playlistId: this.playlistId,
          id: this.video.id
        }
      })
    }
  },
  methods: {
    verifyDemo(evt) {
      if (this.isDemo) {
        evt.preventDefault()
        evt.stopPropagation()
        this.$emit('demoActivated')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.video {
  display: flex;
  flex-direction: column;
  width: 100%;

  a {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    text-decoration: none;
    color: unset;
  }

  .image-container {
    height: 200px;
    border-radius: 16px;
    overflow: hidden;
    flex-grow: 1;

    @media screen and (max-width: 725px) {
      height: 115px;
    }

    @media screen and (max-width: 374px) {
      height: 90px;
    }

    img {
      display: flex;
      width: 100%;
      min-height: 100%;
      height: inherit;
      object-fit: cover;
      background-color: white;
    }
  }

  &.animated .image-container {
    transition: transform 0.3s ease, box-shadow 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0px 4px 16px rgba(82, 53, 167, 0.25);
    }
  }

  &.highlighted {
    .image-container {
      border: 6px solid #C64CFF;
      box-shadow: 0px 0px 14px #C64CFF;
    }
  }

  p {
    margin-top: 10px;
    margin-bottom: 0;
    font-size: 0.9rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-decoration: none;

    @media screen and (max-width: 725px) {
      margin-top: 6px;
    }
  }
}
</style>
